import { getQueryParam } from '../routing/getQueryParam';
import Url from 'urlinator/Url';

const isHubSpotHost = hostname => /(app|local).*\.hubspot(qa)?\.com/.test(hostname);

const isOauthPath = pathname => /^\/oauth\/.*/.test(pathname);

const isHubSpotOauthRedirect = (hostname, pathname) => isHubSpotHost(hostname) && isOauthPath(pathname);

const removeAffiliateCharacterEncoding = url => url.replace(/\+/g, encodeURIComponent(' '));

export const parseScopesFromUrl = scopesInUrl => removeAffiliateCharacterEncoding(scopesInUrl);
export const isOauthFlow = () => {
  const {
    hostname,
    pathname
  } = new Url(getQueryParam('loginRedirectUrl'));
  return isHubSpotOauthRedirect(hostname, pathname);
};